import React, { useState } from 'react';
import { getAvatarUrl } from '../../utils/api';

const Avatar = ({
  entity,
  size = 'md',
  clickable = false,
  onClick,
  title,
  onRemove,
  className = '',
  shape = 'circle',
}) => {
  const [imgError, setImgError] = useState(false);

  // Hämta namn och bildfält
  const name =
    entity?.firstName && entity?.lastName
      ? `${entity.firstName} ${entity.lastName}`
      : entity?.companyName || entity?.supplierName || '';
  // Prioritera avatar: entity.avatar > entity.builder.avatar > entity.supplier.avatar > entity.logo
  const avatarSrc =
    entity?.avatar ||
    entity?.builder?.avatar ||
    entity?.supplier?.avatar ||
    entity?.logo || '';

  // Initialer/första bokstav
  const getInitials = () => {
    if (entity?.firstName && entity?.lastName)
      return `${entity.firstName[0]}${entity.lastName[0]}`.toUpperCase();
    if (entity?.companyName)
      return entity.companyName[0].toUpperCase();
    if (entity?.supplierName)
      return entity.supplierName[0].toUpperCase();
    return '?';
  };

  // Storleksklasser
  const sizeClasses = {
    xxs: 'w-5 h-5 text-[9px]',
    xs: 'w-6 h-6 text-[10px]',
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: shape === 'rectangle' ? 'w-full h-32 text-xl' : 'w-24 h-24 text-xl',
  };

  // Formklass
  const shapeClass = shape === 'rectangle' ? 'rounded-lg' : 'rounded-full';

  // Rendera bild eller initialer
  return (
    <div
      className={`relative ${shapeClass} flex items-center justify-center bg-gray-100 ${sizeClasses[size]} ${clickable ? 'cursor-pointer' : ''} ${className}`}
      tabIndex={0}
      aria-label={title || name}
      title={title || name}
      onClick={onClick}
    >
      {avatarSrc && getAvatarUrl(avatarSrc) && !imgError ? (
        <img
          src={getAvatarUrl(avatarSrc)}
          alt={name}
          className={`${shapeClass} object-contain ${sizeClasses[size]}`}
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="text-gray-600 font-medium">{getInitials()}</span>
      )}
      {/* Ta bort-knapp om onRemove finns */}
      {onRemove && (
        <button
          className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center shadow hover:bg-red-600 transition-colors"
          onClick={e => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label="Ta bort bild"
          title="Ta bort bild"
          tabIndex={0}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default Avatar; 